"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _tabs = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tabs.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _tabs.default));

var Tab = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      glyph = _ref.glyph,
      id = _ref.id,
      selected = _ref.selected,
      _onClick = _ref.onClick,
      tabContentProps = _ref.tabContentProps,
      linkProps = _ref.linkProps,
      index = _ref.index,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["title", "glyph", "id", "selected", "onClick", "tabContentProps", "linkProps", "index", "className", "cssNamespace"]);
  var tabClasses = classnames(className, "".concat(cssNamespace, "-tabs__item"));
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
    "aria-controls": id,
    "aria-selected": selected,
    className: tabClasses,
    key: id,
    ref: ref,
    role: "tab"
  }), /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, linkProps, {
    className: classnames("".concat(cssNamespace, "-tabs__link")),
    href: "#".concat(id),
    onClick: function onClick(event) {
      return _onClick(event, index);
    }
  }), glyph ? /*#__PURE__*/_react.default.createElement("span", {
    className: classnames('fd-tabs__icon')
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaLabel: title,
    glyph: glyph
  })) : /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-tabs__tag"))
  }, title)));
});

Tab.displayName = 'Tab';
Tab.defaultProps = {
  onClick: function onClick() {}
};
process.env.NODE_ENV !== "production" ? Tab.propTypes = {
  /** Localized text for the heading */
  title: _propTypes.default.string.isRequired,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** The icon to include. See the icon page for the list of icons */
  glyph: _propTypes.default.string,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Internal use only */
  index: _propTypes.default.number,

  /** Additional props to be spread to the tab\'s `<a>` element */
  linkProps: _propTypes.default.object,

  /** Internal use only */
  selected: _propTypes.default.bool,

  /** Additional props to be spread to the tab content\'s `<div>` element */
  tabContentProps: _propTypes.default.object,

  /** Internal use only */
  onClick: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(Tab);

exports.default = _default;